import type { ComponentProps, FC } from 'react';
import clsx from 'clsx';

import Icon from './Icon';
import type { SvgIconName } from './Svg';

interface IconBadgeProps extends ComponentProps<'div'> {
  name: SvgIconName;
}

export const IconBadge: FC<IconBadgeProps> = ({ name, className, ...rest }) => (
  <div {...rest} className={clsx('rounded-full bg-white p-0.25 shadow-xl', className)}>
    <Icon className="h-7 w-7" name={name} />
  </div>
);
